import { render, staticRenderFns } from "./SecessionModal.vue?vue&type=template&id=595f2a00&"
import script from "./SecessionModal.vue?vue&type=script&lang=js&"
export * from "./SecessionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports